module.exports = __webpack_public_path__ + "media/images/Venn Diagram-b2a010782c21c936ef8862ee4d038ca8.svg";